class LoadingIndicatorController {
    constructor(loadingIndicatorService) {
        this.loading = loadingIndicatorService;
    }
}

const loadingIndicatorComponentDefinition = {
    controller: ['LoadingIndicatorService', LoadingIndicatorController],
    template: `
        <wow-loading-spinner
            class="loadingIndicator"
            ng-if="$ctrl.loading._isLoading"
            custom-spinner-class="loadingIndicator-spinner"
            message="{{ $ctrl.loading._message }}"
            is-message-sr-only="$ctrl.loading._isMessageSrOnly">
        </wow-loading-spinner>

        <div ng-if="$ctrl.loading._isMasked" class="loadingIndicator-mask"></div>
    `,
};

module.exports = {
    LoadingIndicatorController,
    loadingIndicatorComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/common/loadingindicator/loading-indicator.component.js